import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import "moment/locale/de";
moment.locale("de");
moment.updateLocale("de", {
  week: {
    dow: 1 // Monday is the first day of the week
  }
});

Vue.use(Vuex);

const apiUrl = "https://cheese.azwick.de/api.php";

const UPDATE_DATA = "UPDATE_DATA";
const SET_LOADING = "SET_LOADING";
const ADD_TO_PLAN = "ADD_TO_PLAN";
const REMOVE_FROM_PLAN = "REMOVE_FROM_PLAN";
const SAVE_RECIPE = "SAVE_RECIPE";
const DELETE_RECIPE = "DELETE_RECIPE";
const ADD_NOTE = "ADD_NOTE";
const DELETE_NOTE = "DELETE_NOTE";
const SEARCH_ACTIVE = "SEARCH_ACTIVE";
const SELECTED_DATE = "SELECTED_DATE";
const SET_DETAILITEM = "SET_DETAILITEM";
const SHOW_EDITMODAL = "SHOW_EDITMODAL";

export default new Vuex.Store({
  state: {
    searchActive: false,
    selectedDate: moment().format("YYYY-MM-DD"),
    recipes: [],
    plan: [],
    notes: [],
    moment: moment,
    loading: false,
    detailItem: null,
    modalEditShow: false
  },
  mutations: {
    [SEARCH_ACTIVE](state, yesNo) {
      state.searchActive = yesNo;
    },
    [SELECTED_DATE](state, day) {
      state.selectedDate = moment(day).format("YYYY-MM-DD");
    },
    [UPDATE_DATA](state, data) {
      data.recipes.sort((a, b) => a.title.localeCompare(b.title));
      state.recipes = data.recipes;
      state.plan = data.plan;
      state.notes = data.notes;
    },
    [SET_LOADING](state, loading) {
      state.loading = loading;
    },
    [SET_DETAILITEM](state, detailItem) {
      state.detailItem = detailItem;
    },
    [SHOW_EDITMODAL](state, bol) {
      state.modalEditShow = bol;
    },
    [ADD_TO_PLAN](state, payload) {
      state.plan.push(payload);
    },
    [REMOVE_FROM_PLAN](state, payload) {
      state.plan = state.plan.filter(elem => {
        return !(
          elem.id == payload.id &&
          payload.date.isSame(state.moment(elem.date), "date")
        );
      });
    },
    [SAVE_RECIPE](state, payload) {
      payload.calories = parseInt(payload.calories);
      if (payload.id > 0 || payload.id > "") {
        let targetIndex = state.recipes.findIndex(
          recipe => recipe.id === payload.id
        );
        if (targetIndex !== false) {
          state.recipes[targetIndex] = Object.assign(
            {},
            state.recipes[targetIndex],
            payload
          );
        }
      } else {
        payload.id = uuidv4();
        state.recipes.push(payload);
      }
    },
    [DELETE_RECIPE](state, payload) {
      if (payload.id > 0 || payload.id > "") {
        let targetIndex = state.recipes.findIndex(
          recipe => recipe.id === payload.id
        );
        if (targetIndex !== false) {
          state.recipes.splice(targetIndex, 1);
        }
      }
    },
    [ADD_NOTE](state, payload) {
      state.notes[payload].entries.push({ title: "" });
    },
    [DELETE_NOTE](state, payload) {
      state.notes[payload.categoryIndex].entries.splice(
        payload.ingredientIndex,
        1
      );
    }
  },
  actions: {
    getData({ commit }) {
      commit(SET_LOADING, true);
      return axios.get(apiUrl + "?get").then(r => {
        commit(UPDATE_DATA, r.data);
        commit(SET_LOADING, false);
      });
    },
    saveState({ commit, state }) {
      commit;
      state;
      return false;
      // return fetch(apiUrl + "?set", {
      //   method: "post",
      //   headers: {
      //     Accept: "application/json, text/plain, */*",
      //     "Content-Type": "application/json"
      //   },
      //   body: JSON.stringify(state)
      // })
      //   .then(res => res.json())
      //   .then(dataParsed => {
      //     commit(UPDATE_DATA, dataParsed);
      //     commit(SET_LOADING, false);
      //   });
    },
    addToPlan({ commit, dispatch }, payload) {
      commit(SET_LOADING, true);
      commit(ADD_TO_PLAN, payload);
      return dispatch("saveState");
    },
    removeFromPlan({ commit, dispatch }, payload) {
      commit(SET_LOADING, true);
      commit(REMOVE_FROM_PLAN, payload);
      return dispatch("saveState");
    },
    saveRecipe({ commit, dispatch }, payload) {
      commit(SET_LOADING, true);
      commit(SAVE_RECIPE, payload);
      return dispatch("saveState");
    },
    deleteRecipe({ commit, dispatch }, payload) {
      commit(SET_LOADING, true);
      commit(DELETE_RECIPE, payload);
      return dispatch("saveState");
    },
    deleteNote({ commit, dispatch }, payload) {
      commit(SET_LOADING, true);
      commit(DELETE_NOTE, payload);
      return dispatch("saveState");
    }
  },
  getters: {
    // ...
    getRecipeById: state => id => {
      return state.recipes.find(recipe => recipe.id === id);
    },
    getRecipesByDate: (state, getters) => date => {
      var result = [];
      state.plan.forEach(entry => {
        if (state.moment(entry.date).isSame(date, "date")) {
          result.push(getters.getRecipeById(entry.id));
        }
      });
      return result;
    },
    getItemVariantColor: () => type => {
      if (type.includes("V")) {
        return "success";
      } else if (type.includes("M")) {
        return "danger";
      } else if (type.includes("A")) {
        return "info";
      } else if (type.includes("N")) {
        return "purple";
      }
      return "primary";
    }
  },
  modules: {}
});
